import React, { useEffect, useState } from 'react';
import { INavStyles, INavLinkGroup } from '@fluentui/react/lib/Nav';
import { BwjNav } from '../../framework/components/bwj-nav';
import { AppLinks } from '../../app/app-links';
import { useEventNotification } from '../../framework/services/event-notification';
import { AppRoutes } from '../../app/app-routes';
import { AppMenuEvents } from '../../events/app-menu';
import { getTheme, IStyle, mergeStyleSets, PanelType } from '@fluentui/react';
import { BwjSidePanel } from '../../framework/components/bwj-side-panel';
import { xlate, xlationContext } from '../../framework/utils/i18n';

xlationContext('Application main menu');
interface IAppSideNavProps {
  invokeShowMobileNav: {} | undefined;
  showDesktopNav: boolean;
}

const getStyleClasses = () => {
  const desktopMenu: IStyle = {
    display: 'none',
    width: 220,
    height: '100%',

    '& > .ms-FocusZone': {
      height: '100%',
    },

    '@media(min-width: 501px)': {
      display: 'block',
    },
  };

  return mergeStyleSets({
    desktopMenu,
  });
};

const getNavStyles = (): Partial<INavStyles> => {
  const theme = getTheme();
  return {
    root: {
      width: '100%',
      height: '100%',
      boxSizing: 'border-box',
      border: 'none',
      backgroundColor: theme.palette.neutralLighter,
      overflowY: 'auto',
    },
    // these link styles override the default truncation behavior
    link: {
      lineHeight: 'inherit',
    },
  };
};

const navLinkGroups: INavLinkGroup[] = [
  {
    links: [
      {
        name: 'Home',
        url: AppRoutes.home.url(),
        icon: AppRoutes.home.icon,
        key: AppRoutes.home.key,
      },
      ...AppLinks
    ],
  },
];

const subscriberId = 'Component.AppSideNav';

export const AppSideNav: React.FunctionComponent<IAppSideNavProps> = (props) => {
  const { invokeShowMobileNav } = props;
  const [selectedKey, setSelectedKey] = useState('none');
  const [showMobileNav, setShowMobileNav] = useState(false);
  const styles = getStyleClasses();
  const navStyles = getNavStyles();

  useEventNotification((key: string) => setSelectedKey(key), [], AppMenuEvents.ChangeSelectedLink, subscriberId);

  useEffect(() => {
    setShowMobileNav(invokeShowMobileNav !== undefined);
  }, [invokeShowMobileNav]);

  return (
    <>
      <BwjSidePanel
        showPanel={showMobileNav}
        title={xlate('Presentual')}
        panelType={PanelType.smallFixedNear}
        onDismiss={() => setShowMobileNav(false)}
        closeButtonAriaLabel={xlate('Close main menu')}
      >
        <BwjNav
          selectedKey={selectedKey}
          ariaLabel={xlate('Main menu')}
          styles={navStyles}
          groups={navLinkGroups}
          onLinkClick={() => setShowMobileNav(false)}
        />
      </BwjSidePanel>
      {props.showDesktopNav &&
      <div className={styles.desktopMenu}>
        <BwjNav
          selectedKey={selectedKey}
          ariaLabel={xlate('Main menu')}
          styles={navStyles}
          groups={navLinkGroups}
        />
      </div>}
    </>
  );
};
